import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { IconButtonComponent } from "@hermes/aphrodite/icon-button";
import {
    svgCameraFlash,
    SvgIconComponent,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";

import { VirtualTryOnButtonComponent } from "./components/virtual-try-on-button.component";
import { VtoModalServiceModule } from "./services/vto-modal.service.module";

@NgModule({
    imports: [
        CommonModule,
        SvgIconComponent,
        IconButtonComponent,
        VtoModalServiceModule,
    ],
    declarations: [VirtualTryOnButtonComponent],
    exports: [VirtualTryOnButtonComponent],
})
export class VtoCallToActionComponent {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([svgCameraFlash]);
    }
}
